export const Search = {
  Criteria: {
    name: 'search',
    path: '/search'
  },
  Results: {
    name: 'searchResults',
    path: '/search/results/:savedSearchId?'
  },
  DefaultDocumentView: {
    name: 'documentView',
    path: '/search/documentView/:cabinetId/:documentId'
  }
};
